import { Link } from "react-router-dom";
import CharacterCard from "@/components/base/CharacterCard";
import SectionHeading from "@/components/base/SectionHeading";
import { characters } from "@/mocks/characters";

export default function FeaturedCharacters() {
  const featured = characters.filter((c) => c.featured).slice(0, 4);
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <SectionHeading
          eyebrow="人气女主"
          title="本周高人气妖精漫画女主"
          desc="颜值与人设都在线的漂亮女主精选，萌娘属性与CP组合一目了然，点进卡片看完整角色介绍。"
        />
        <Link
          to="/encyclopedia"
          className="mb-8 inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200 px-4 py-2 text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-700 md:mb-10"
        >
          查看全部
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {featured.map((c) => (
          <div key={c.slug} className="reveal">
            <CharacterCard character={c} />
          </div>
        ))}
      </div>
    </section>
  );
}